import { useState } from "react";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { useEligibility } from "@/contexts/EligibilityContext";
import AssessmentPreview from "@/components/eligibility/AssessmentPreview";
import AssessmentResults from "@/components/eligibility/AssessmentResults";
import PageHeader from "@/components/PageHeader";
import VisaPathwaySelection, { VisaPathway } from "@/components/eligibility/VisaPathwaySelection";
import EligibilityAssessmentForm from "@/components/eligibility/EligibilityAssessmentForm";
import EB1AAssessmentForm from "@/components/eligibility/forms/EB1AAssessmentForm";
import DubaiGoldenVisaForm from "@/components/eligibility/forms/DubaiGoldenVisaForm";
import HighPotentialForm from "@/components/eligibility/forms/HighPotentialForm";

const EligibilityAssessment = () => {
  const [selectedPathway, setSelectedPathway] = useState<VisaPathway | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [assessmentData, setAssessmentData] = useState<any>(null);
  const { user } = useAuth();
  const { temporaryData } = useEligibility();

  const handlePathwaySelect = (pathway: VisaPathway) => {
    setSelectedPathway(pathway);
    setIsSubmitted(false);
    setAssessmentData(null);
  };

  const handleBack = () => {
    setSelectedPathway(null);
    setIsSubmitted(false);
    setAssessmentData(null);
  };

  const handleComplete = (data: any) => {
    setAssessmentData(data);
    setIsSubmitted(true);
  };

  const renderAssessmentForm = () => {
    if (isSubmitted) {
      return user ? (
        <AssessmentResults data={{ ...assessmentData, visaPathway: selectedPathway }} />
      ) : (
        <AssessmentPreview data={{ ...assessmentData, visaPathway: selectedPathway }} />
      );
    }

    switch (selectedPathway?.id) {
      case "eb1":
        return <EB1AAssessmentForm onComplete={handleComplete} />;
      case "dubai-golden":
        return <DubaiGoldenVisaForm onComplete={handleComplete} />;
      case "high-potential":
        return <HighPotentialForm onComplete={handleComplete} />;
      default:
        return (
          <EligibilityAssessmentForm
            visaPathway={selectedPathway}
            onBack={handleBack}
            onComplete={handleComplete}
          />
        );
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <PageHeader 
        title="Check Your Eligibility"
        subtitle="Find the best migration pathways for your profile"
        showCta={false}
      />
      
      <div className="p-6">
        <div className="max-w-4xl mx-auto">
          <Card className="p-6">
            {selectedPathway ? (
              renderAssessmentForm()
            ) : (
              <VisaPathwaySelection onSelect={handlePathwaySelect} />
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default EligibilityAssessment;